import { render, staticRenderFns } from "./form-adjustments.vue?vue&type=template&id=49a7858d&scoped=true"
import script from "./form-adjustments.vue?vue&type=script&lang=js"
export * from "./form-adjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7858d",
  null
  
)

export default component.exports